module.exports = __webpack_public_path__ + "static/unveil-logo-b66940ca65da43dd63695539e3052ed6.svg";